import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';

export interface ConfirmationModalConfig {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonType?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
  confirmButtonDanger?: boolean;
  showTextarea?: boolean;
  textareaPlaceholder?: string;
  textareaValue?: string;
  textareaRequired?: boolean;
  processing?: boolean;
  showDatePicker?: boolean;
  dateValue?: Date;
  dateRequired?: boolean;
}

@Component({
  selector: 'app-confirmation-modal',
  standalone: false,
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.less'
})
export class ConfirmationModalComponent {
  @Input() config: ConfirmationModalConfig = {
    title: 'Confirmar acción',
    message: '¿Estás seguro de que deseas realizar esta acción?',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    confirmButtonType: 'primary',
    confirmButtonDanger: false,
    showTextarea: false,
    textareaPlaceholder: '',
    textareaValue: '',
    textareaRequired: false,
    processing: false,
    showDatePicker: false,
    dateValue: new Date(),
    dateRequired: false
  };

  @Output() confirmed = new EventEmitter<{textValue?: string, dateValue?: Date}>();
  @Output() cancelled = new EventEmitter<void>();

  @ViewChild('modalTemplate', { static: true }) modalTemplate!: TemplateRef<any>;

  private modalRef: any;

  constructor(private modalService: NzModalService) {}

  open(): void {
    this.modalRef = this.modalService.create({
      nzTitle: undefined,
      nzClosable: false,
      nzWidth: 518,
      nzFooter: null,
      nzContent: this.modalTemplate,
      nzCentered: true,
    });
  }

  close(): void {
    this.modalRef?.close();
    this.cancelled.emit();
  }

  forceClose(): void {
    this.modalRef?.close();
  }

  confirm(): void {
    this.confirmed.emit({
      textValue: this.config.textareaValue,
      dateValue: this.config.dateValue
    });
    // No cerrar automáticamente si está en estado de processing
    if (!this.config.processing) {
      this.close();
    }
  }

  isConfirmDisabled(): boolean {
    if (this.config.processing) return true;
    if (this.config.showTextarea && this.config.textareaRequired && !this.config.textareaValue?.trim()) {
      return true;
    }
    if (this.config.showDatePicker && this.config.dateRequired && !this.config.dateValue) {
      return true;
    }
    return false;
  }
}
